import { BaseApi } from '@/modules/core/base.api';
import { Subscription } from './subscription';
import { User } from '@/modules/user/user';
import * as API from '@/shared/common/api';
import { PaginationResult } from '@shared/common/types';

class SubscriptionApi extends BaseApi {
    public apiPath = 'subscription';

    public async findAll(options: object & { page: number }): Promise<PaginationResult<Subscription>>;
    public async findAll(options?: object): Promise<Subscription[]>;
    public async findAll(options: any = {}): Promise<Subscription[] | PaginationResult<Subscription>> {
        const response = await this.api.get(this.baseUrlFor(), {
            params: {
                ...options,
            },
        });

        if (response.data.items) {
            response.data.items = response.data.items.map((subscription: any) => new Subscription(subscription));
        } else {
            response.data = response.data.map((subscription: any) => new Subscription(subscription));
        }

        return response.data;
    }

    public async create(subscription: any): Promise<API.CreateSubscription> {
        const response = await this.api.post<API.CreateSubscription>(this.baseUrlFor(), subscription);
        return response.data;
    }

    public async update(subscription: any): Promise<API.UpdateSubscription> {
        const response = await this.api.put<API.UpdateSubscription>(this.baseUrlFor(subscription.id), subscription);
        return response.data;
    }

    public async get(id: string): Promise<API.GetSubscription> {
        const response = await this.api.get<API.GetSubscription>(this.baseUrlFor(id));
        return response.data;
    }

    public async getCount(options: any): Promise<API.GetSubscriptionCount> {
        const response = await this.api.get<API.GetSubscriptionCount>(this.baseUrlFor('count'), {
            params: {
                ...options,
            },
        });
        return response.data;
    }

    public async remove(id: string): Promise<API.DeleteSubscription> {
        const response = await this.api.delete<API.DeleteSubscription>(this.baseUrlFor(id));
        return response.data;
    }

    public createInstance(subscription: any): Subscription {
        const subscriptionInstance = new Subscription(subscription);

        if (subscription.createdBy) {
            subscriptionInstance.createdBy = new User(subscription.createdBy);
        }

        if (subscription.updatedBy) {
            subscriptionInstance.updatedBy = new User(subscription.updatedBy);
        }

        return subscriptionInstance;
    }
}

export const subscriptionApi = new SubscriptionApi();
